const config = {
  rowSelection: true,
  columns: [
    {
      title: '收款单号',
      dataIndex: 'transactionCode',
      width: 190,
      ellipsis: true,
    },
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '第三方订单号',
      dataIndex: 'shjThirdOrderNoInfo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '第三方合同号',
      dataIndex: 'shjThirdContractNoInfo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '门店',
      dataIndex: 'companyName',
      width: 150
    },
    {
      title: '客户名称',
      dataIndex: 'customerName',
      width: 150
    },
    {
      title: '支付方式',
      dataIndex: 'paymentMethodName',
      width: 150
    },
    {
      title: '收款金额',
      dataIndex: 'amount',
      width: 140,
    },
    {
      title: '已核销金额',
      dataIndex: 'verifiedAmount',
      width: 140,
    },
    {
      title: '未核销金额',
      dataIndex: 'unverifiedAmount',
      width: 140
    },
    {
      title: '核销状态',
      dataIndex: 'verifyStateName',
      width: 100
    },
    {
      title: '交易类型',
      dataIndex: 'transactionTypeName',
      width: 120
    },
    {
      title: '交易流水号',
      dataIndex: 'paymentOrderTransactionId',
      width: 180,
      ellipsis: true,
    },
    {
      title: '收款日期',
      dataIndex: 'receivedDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '到账日期',
      dataIndex: 'accountingDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '签单日期',
      dataIndex: 'signDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '开工日期',
      dataIndex: 'actualStartDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '完工日期',
      dataIndex: 'actualEndDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '确认收款操作时间',
      dataIndex: 'receivedClickDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '是否客户收款',
      dataIndex: 'customerReceiptFlag',
      render: 'receiptFlagOperate',
      width: 150
    },
    {
      title: '收款状态',
      dataIndex: 'stateName',
      width: 120
    },
    {
      title: '收款账户',
      dataIndex: 'cardNo',
      ellipsis: true,
      width: 180
    },
    {
      title: '付款账户',
      dataIndex: 'paymentAccount',
      ellipsis: true,
      width: 180
    },
    {
      title: '来源类型',
      dataIndex: 'sourceTypeName',
      width: 140,
      ellipsis: true,
    },
    {
      title: '打印状态',
      dataIndex: 'printStateName',
      width: 120
    },
    {
      title: '收据方式',
      dataIndex: 'printTypeName',
      width: 120
    },
    {
      title: '收据编号',
      dataIndex: 'printNo',
      ellipsis: true,
      width: 180
    },
    {
      title: '备注',
      dataIndex: 'description',
      width: 200,
      ellipsis: true,
    },
  ],
  search: [
    {
      name: 'contractNo',
      label: '合同号',
    },
    {
      name: 'orderNo',
      label: '订单号',
    },
    {
      name: 'customerPhone',
      label: '客户电话',
    },
    {
      name: 'customerName',
      label: '客户名称',
    },
    {
      name: 'transactionCode',
      label: '收款单号',
    },
    {
      name: 'shjThirdOrderNo',
      label: '第三方订单号',
      itemType: 'number',
    },
    {
      name: 'shjThirdContractNo',
      label: '第三方合同号',
      itemType: 'number',
    },
    {
      name: 'companyOrgIdList',
      label: '门店',
      placeholder: '门店',
      itemType: 'select',
      key: 'orgId',
      labelKey: 'companyName',
      data: 'companyList',
    },
    {
      name: 'paymentMethodList',
      label: '支付方式',
      itemType: 'select',
      data: 'paymentMethodList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'verifyStateList',
      label: '核销状态',
      itemType: 'select',
      data: 'verifyStateList',
      mode: 'multiple',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'customerReceiptFlag',
      label: '是否客户收款',
      itemType: 'select',
      data: 'customerReceiptFlagList',
      labelKey: 'name',
      key: 'id',
    },
    {
      name: 'stateList',
      label: '收款状态',
      itemType: 'select',
      data: 'receiptStateList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'transactionTypeList',
      label: '交易类型',
      itemType: 'select',
      data: 'transactionFeeTypeList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'receivedDate',
      label: '收款日期',
      itemType: 'autoDate',
      allowClear: 'true'
    },
    {
      name: 'confirmDate',
      label: '到账日期',
      itemType: 'autoDate',
      allowClear: 'true'
    },
    {
      name: 'receivedClickDate',
      label: '确认收款操作时间',
      itemType: 'autoDate',
      allowClear: 'true'
    }
  ],
  footer: [

  ],
  batchActions: [
    {
      label: '批量确认到账',
      type: 'primary',
      auth: 'PaymentDetailsConfirmReceipt',
      events: ['onClick:onConfirmReceiptShowModal'],
    }
  ]
}

export default config
